import {PatchUpdatePhoneParams} from 'domain/usecases';
import {makePatchUpdatePhone} from 'main/factories/usecases';

export async function patchUpdatePhone(params: PatchUpdatePhoneParams) {
	await makePatchUpdatePhone().patch(params);

	return params;
}
